import { render } from "./EditAdjustmentPage.vue?vue&type=template&id=4d049674&ts=true"
import script from "./EditAdjustmentPage.vue?vue&type=script&lang=ts"
export * from "./EditAdjustmentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__